import { Component, ElementRef, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { EditableComponent } from '../editable.types';

@Component({
  templateUrl: './checkbox-editable.component.html',
  styleUrls: ['./checkbox-editable.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckboxEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  public value;
  public editing: boolean = false;

  public options: any[] = [
    { id: 'true', value: 'Yes' },
    { id: 'false', value: 'No' },
    { id: 'null', value: 'Not Set' },
  ];
  private _originalValue;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.getValue();

    if (this.value !== 'null') {
      let booleanValue = new Boolean(this.value);

      if (booleanValue === true || booleanValue === false) {
        this.value = JSON.parse(this.value.toString());
        this._originalValue = this.value;
      }
    }

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
  }

  edit() {
    if (!this.editing && !this.isDisabled) {
      this.editing = true;
    }
  }

  onSelectionChange($event: Event) {
    this.onSave();
    this.editing = false;
  }

  onBlur($event: Event) {
    this.onSave();
    this.editing = false;
  }

  onSave() {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: JSON.parse(this.value) });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  displayValue(value) {
    if (String(value) === 'true') {
      return 'Yes';
    } else if (String(value) === 'false') {
      return 'No';
    } else {
      return 'Not Set';
    }
  }
}
